
@if (isModal){
  <app-modal-close-button />
}

@if (itemDetails()){
  <ion-content class="item-details" [scrollEvents]="true" (ionScrollStart)="tools.toggleMenu($event)">

    @if (itemDetails().name) {
      <header-details 
          [name]="itemDetails().name" 
          [type]="itemDetails().type" 
          [id]="itemDetails().id" 
          [duration]="itemDetails()?.duration"
          [accessibilityList]="itemDetails()?.accessibility"
      />
    }

    @if (itemDetails()?.audioguides?.[translate.currentLang]?.length > 0 || 
         itemDetails()?.gpxFile?.[translate.currentLang]?.length > 0     || 
         itemDetails()?.kmzFile?.[translate.currentLang]?.length > 0
    ){
      <div class="hero-buttons-container">
        @if (itemDetails()?.audioguides?.[translate.currentLang]?.length > 0){
          <div class="select-dropdown-container">
            <select-dropdown 
                [items]="itemDetails().audioguides[translate.currentLang]" 
                (urlEmitter)="setAudio($event)"
            />
          </div>
        }

        @if(itemDetails()?.gpxFile?.[translate.currentLang]?.length > 0){
          <button class="gpx-button" (click)="downloadGpxFile()">
            <img src="/assets/imgs/icono-gpx.png" />
            <span>{{'Descargar Ruta' | translate}} GPX</span>
          </button>
        }

        @if(itemDetails()?.kmzFile?.[translate.currentLang]?.length > 0){
          <button class="gpx-button" (click)="downloadKmzFile()">
            <img src="/assets/imgs/icono-kmz.webp" />
            <span>{{'Descargar Ruta' | translate}} KMZ</span>
          </button>
        }
      </div>
    }



    @if (itemDetails().multimedia?.length > 0) {
        <details-hero 
            [items]="itemDetails().multimedia" 
            [isModal]="isModal" 
        />
    }
    
    @if (itemDetails().action_buttons || itemDetails().photo_360) {
      <details-action-buttons 
          [actionButtons]="itemDetails().action_buttons" 
          [image360]="itemDetails().photo_360" 
          [speaker]="itemDetails().speaker" 
          [itemId]="itemDetails().id"
      />
    }

    <div class="details-content" [class.expand]="audioSrc()">
      <div class="details__grid-content">
        <div class="grid-content__left">
          @if (itemDetails().description) {
            <details-description [description]="itemDetails().description" />
          }
          
          @if (itemDetails().extra_fields) {
            <details-extra-fields [extraFields]="itemDetails().extra_fields" />
          }
        </div>
        
        <div class="grid-content__right">
          @if (itemDetails().location?.address) {
            <details-location [location]="itemDetails().location" />
          }
          
          @if (itemDetails().dateRange?.start && itemDetails().dateRange?.end) {
              <details-date-range 
                  [start]="itemDetails().dateRange.start" 
                  [end]="itemDetails().dateRange.end" />
          }

          @if (itemDetails().schedule) {
              <details-schedule [schedule]="itemDetails().schedule" />
          }
          
          @if (itemDetails().price) {
              <details-price [price]="itemDetails().price" />
          }
        </div>
      </div>
      
      @if (itemDetails()?.type === 'hiking' && gpxData()){
        <div class="map-container">
          <app-details-gpx-route 
            [gpxData]="gpxData()" 
            [coordinates]="itemDetails()?.location" 
          />
        </div>
      }
      
      @if (itemDetails().offers?.length > 0) {
        <details-offers [offers]="itemDetails().offers" />
      }

      @if (itemDetails().tags) {
        <app-tags [tags]="itemDetails().tags" />  
      }
    </div>
  </ion-content>
}

@if(audioSrc()){
    <div class="player-wrapper" @fadeSlide>
        <audio-player 
            [src]="audioSrc()"
            (closeEmitter)="closeAudioPlayer()"  
        />
    </div>
}

<!---- ACTIONS BUTTONS MODAL --------------------------------------------------------------------------------------------->

@if(isModal && addItem){
    <div class="modal-button-container">
      <button (click)="acceptItem()">{{'Añadir a la ruta' | translate}}</button>
    </div>
}
  
@if(isModal && removeItem){
    <div class="modal-button-container">
      <button class="remove-item" (click)="acceptItem()">{{'Eliminar de la ruta' | translate}}</button>
    </div>
}
  